import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import MainLayout from "@/components/layout/MainLayout";
import AlojamientoCreateForm from "@/features/alojamientos/components/forms/AccommodationForm";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { HomeIcon, Building2Icon } from "lucide-react";
import { Link } from "react-router-dom";
import { AuthDebugPanel } from '@/features/auth/components/AuthDebugPanel';

const Index = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const mode = id ? "edit" : "create";

  const handleCreated = (newId: string) => {
    // Redirige al nuevo path, lo que reinicia el componente en modo edición
    navigate(`/accommodation/${newId}`);
  };

  return (
    <MainLayout>
      <div className="space-y-6">
        <div>
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink href="/">
                  <HomeIcon className="h-4 w-4 mr-1" />
                  <span>Inicio</span>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage>
                  {mode === 'edit' ? 'Editar Establecimiento' : 'Nuevo Establecimiento'}
                </BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>

          <div className="flex justify-between items-center">
            <div>
              <h1 className="text-3xl font-bold mt-2 text-gray-900 mt-6">
                {mode === 'edit' ? 'Editar Establecimiento' : 'Nuevo Establecimiento'}
              </h1>
              <p className="text-muted-foreground mt-1">
                {mode === 'edit'
                  ? 'Modifique los datos del establecimiento según sea necesario'
                  : 'Complete el formulario para crear un nuevo alojamiento en el sistema'}
              </p>
            </div>

{/*             <Link
              to="/accommodation/1"
              className="text-blue-600 hover:underline"
            >
              Ver ejemplo de detalle
            </Link> */}
          </div>
        </div>

        <AlojamientoCreateForm
          establishmentId={id}
          mode={mode}
          onCreated={handleCreated}
        />

        {/* Debug Panel - Solo para testing */}
        <AuthDebugPanel show={false} />
      </div>
    </MainLayout>
  );
};

export default Index;
